import { UiKitCarouselBase } from '@/fo/ui/kit/carousel/base';
import { staticMediaUrl } from '@/fo/util/image-loader';

import { styles } from './Efficiency.styles';

const media = (path: string) =>
  staticMediaUrl(`landing/bioderma-hydrabio/${path}`);

const cards = [
  {
    id: 'tolerance',
    desktop: media('efficiency/1-desktop.webp'),
    mobile: media('efficiency/1-mobile.webp'),
    bottom: true,
    title: 'Высокая переносимость кожей и слизистой глаз'
  },
  {
    id: 'without',
    desktop: media('efficiency/card-2_new.jpg'),
    mobile: media('efficiency/mob-2_new.jpg'),
    without: true
  },
  {
    id: 'unique',
    desktop: media('efficiency/3-desktop.webp'),
    mobile: media('efficiency/3-mobile.webp'),
    bottom: true,
    title: 'Уникальная эффективность увлажнения',
    text: 'Даже в условиях активного ритма жизни и изменения влажности и температур'
  },
  {
    id: 'tested',
    desktop: media('efficiency/4-desktop.webp'),
    mobile: media('efficiency/4-mobile.webp'),
    dark: true,
    title: 'Протестировано под дерматологическим контролем'
  }
];

/** Слайдер эффективности */
export function Efficiency() {
  const slots = styles();

  return (
    <section id="efficiency">
      <UiKitCarouselBase
        className={slots.base()}
        showArrows={false}
        loop={false}
      >
        {cards.map((card) => {
          const cardSlots = styles({ tone: card.dark ? 'dark' : 'light' });

          return (
            <article
              key={card.id}
              className={cardSlots.card({
                className: card.bottom ? cardSlots.bottom() : undefined
              })}
            >
              <picture>
                <source
                  srcSet={card.mobile}
                  media="(max-width: 767px)"
                />
                <img
                  className={cardSlots.image()}
                  src={card.desktop}
                  alt=""
                />
              </picture>
              {card.without ? (
                <p className={cardSlots.without()}>
                  <span className={cardSlots.withoutMain()}>без</span>
                  <span className={cardSlots.withoutDetails()}>
                    спирта
                    <br />
                    силикона
                  </span>
                </p>
              ) : (
                <>
                  <p className={cardSlots.title()}>{card.title}</p>
                  {card.text && <p className={cardSlots.text()}>{card.text}</p>}
                </>
              )}
            </article>
          );
        })}
      </UiKitCarouselBase>
    </section>
  );
}
